export enum BorrowNoteType {
    Effective = 1,
    NoteBorrow = 2
}


// WEBPACK FOOTER //
// ./src/app/shared/enums/BorrowNote.ts